import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchAdminContacts(
  isFilterByAdminId = false,
  searchBy = "",
  value = ""
) {
  const { data } = await http(
    `admin/contacts?filterByAdminId=${isFilterByAdminId}${
      searchBy !== "" && value !== "" ? `&${searchBy}=${value}` : ""
    }`
  );

  return data;
}

export function useAdminContacts() {
  const { data, ...raResult } = useQuery(["admin-contacts"], () =>
    fetchAdminContacts()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
export async function fetchBindedAdminContacts(isFilterByAdminId = true) {
  const { data } = await http(
    `admin/contacts?filterByAdminId=${isFilterByAdminId}`
  );

  return data;
}

export function useBindedAdminContacts() {
  const { data, ...raResult } = useQuery(["binded-admin-contacts"], () =>
    fetchBindedAdminContacts()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

async function addAdminContact(data) {
  const res = await http(`/admin/contacts`, {
    method: "POST",
    data: data,
  });
  return res;
}

export function useAddAdminContact() {
  const queryClient = useQueryClient();

  return useMutation(addAdminContact, {
    onSuccess: async (res) => {
      if (res?.status === 201 || res?.status === 200) {
        await queryClient.invalidateQueries(["admin-contacts"]);
      }
    },
  });
}
async function deleteAdminContact(formData) {
  const data = await http(`/admin/contacts`, {
    method: "DELETE",
    data: formData,
  });

  return data;
}

export function useDeleteAdminContact() {
  const queryClient = useQueryClient();

  return useMutation(deleteAdminContact, {
    onSuccess: () => {
      queryClient.invalidateQueries(["admin-contacts"]);
    },
  });
}

async function bindAdminContact(formData) {
  const data = await http(`/admin/contacts/bind`, {
    method: "PATCH",
    data: formData,
  });

  return data;
}

export function useBindAdminContact() {
  const queryClient = useQueryClient();

  return useMutation(bindAdminContact, {
    onSuccess: () => {
      queryClient.invalidateQueries(["admin-contacts"]);
      queryClient.invalidateQueries(["binded-admin-contacts"]);
    },
  });
}

async function unbindAdminContact(formData) {
  const data = await http(`/admin/contacts/unbind`, {
    method: "PATCH",
    data: formData,
  });

  return data;
}

export function useUnbindAdminContact() {
  const queryClient = useQueryClient();

  return useMutation(unbindAdminContact, {
    onSuccess: () => {
      queryClient.invalidateQueries(["admin-contacts"]);
      queryClient.invalidateQueries(["binded-admin-contacts"]);
    },
  });
}

export async function fetchUser() {
  const { data } = await http(
    `admin/me`
  );

  return data;
}

export function useGetUser() {
  const { data, ...raResult } = useQuery(["user"], () =>
    fetchUser()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}